export default __webpack_public_path__ + "static/media/gallery-7-4.dc32f81c.webp";